import { render } from "./GeneralLedger.vue?vue&type=template&id=3da73b3a&scoped=true"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"

import "./GeneralLedger.vue?vue&type=style&index=0&id=3da73b3a&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da73b3a"]])

export default __exports__